import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IHotel, IResponse } from 'src/app/@Interfaces';
import { ConfigService, SnackbarService } from 'src/app/@Services';
import { HotelService } from 'src/app/@Services/hotel.service';
import { NgClass, DecimalPipe } from '@angular/common';
@Component({
  selector: 'hotels',
  templateUrl: './hotels.component.html',
  styleUrls: ['./hotels.component.scss'],
  imports: [NgClass, DecimalPipe],
})
export class HotelsComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private hotelService: HotelService,
    private snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef,
  ) {}

  @Input() set search(searchVal: string) {
    if (!searchVal) {
      this.displayedHotels = this.hotelService.hotels;
      return;
    }

    const trimmedSearch = searchVal.replace(/\s+/g, '');

    this.displayedHotels = this.hotelService.hotels.filter((hotel) => {
      return (
        hotel.contact_name
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(trimmedSearch) ||
        hotel.hotel_name
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(trimmedSearch) ||
        hotel.hotel_id.toString().replace(/\s+/g, '').includes(trimmedSearch)
      );
    });
  }

  protected displayedHotels: IHotel[] = [];

  ngOnInit(): void {
    this.setHotels();
  }

  protected toggleHotelView(hotel: IHotel): void {
    hotel.extended = !hotel.extended;
  }

  protected signInToHotel(hotel: IHotel, event: Event): void {
    event.stopPropagation();
    this.http
      .post<IResponse<{ impersonate_token: string }>>(`/api/auth/impersonate`, {
        hotel_id: hotel.hotel_id,
      })
      .subscribe({
        next: (res: IResponse<{ impersonate_token: string }>) => {
          console.log('res', res);
          const impersonateUrl = `${this.configService.appServer}?impersonate_token=${res.data.impersonate_token}`;
          window.location.href = impersonateUrl;
        },
        error: () => {
          console.log('err');
        },
      });
  }

  protected getHotelStatus(hotel: IHotel): string[] {
    const classes = [];
    if (hotel.extended) {
      classes.push('extended');
    }
    if (!hotel.active) {
      classes.push('inactive');
      return classes;
    }

    const paidTill = new Date(hotel.paid_till);
    const invoicedTill = new Date(hotel.invoiced_till);
    const today = new Date();

    paidTill.setHours(0, 0, 0, 0);
    invoicedTill.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (paidTill.getTime() < today.getTime()) {
      classes.push('missing-payment');
      return classes;
    }
    if (invoicedTill.getTime() < today.getTime()) {
      classes.push('missing-invoice');
      return classes;
    }
    classes.push('done');
    return classes;
  }

  protected copyText(text: string, event: Event): void {
    event.stopPropagation();
    navigator.clipboard.writeText(text);
    this.snackbarService.openOkSnackBar({ success_text: 'copy' });
  }

  private setHotels(): void {
    this.hotelService
      .setHotels()
      .then(() => {
        this.displayedHotels = this.hotelService.hotels;
        this.cdr.detectChanges();
      })
      .catch(() => {});
  }
}
